module.exports = __webpack_public_path__ + "static/icons/icon-diners-logo.fb42a36.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons-tarjeta-credito/icon-diners-logo.svg
// module id = AXwZ
// module chunks = 1